import confetti from 'canvas-confetti';

export function fireConfetti(element: HTMLElement | null, options: confetti.Options = {}) {
  if (element == null) {
    return;
  }
  const bounds = element.getBoundingClientRect();
  confetti({
    startVelocity: 30,
    disableForReducedMotion: true,
    // TODO: See if we can grab colors from the theme, and also if we can
    // use rgba colors (the library docs says to use hex colors).
    // These were picked by design from the brand colors, but can be changed.
    colors: ['#006FF5', '#B8FF99', '#FFCD00', '#22A800', '#0E464D'],
    scalar: 0.6,
    ...options,
    origin: {
      x: (bounds.left + bounds.width / 2) / window.innerWidth,
      y: (bounds.top + bounds.height / 2) / window.innerHeight,
    },
  });
}
